import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { CompanyBase } from '~types/company';

import QueryKeys from '../queryKeys';

interface CompanyRelationsResponse {
  type: 'RELATION' | 'LIVE';
  companies: CompanyBase[];
}

const getUrl = (id?: string) => `/api/company/${id}/relations`;

/**
 * 연관기업 또는 실시간 검색 기업의 데이터 조회
 *
 * 연관기업의 데이터가 없는경우는 큐에 쌓인 실시간으로 검색된 데이터를 서버에서 반환하고 type으로 데이터유형 구분(RELATION | LIVE)
 * @param id 기업의 hash값
 */
export function useGetCompanyRelations(id: string) {
  return useQuery<CompanyRelationsResponse>(
    [QueryKeys.companyRelations, id],
    () => fetcher<CompanyRelationsResponse>(getUrl(id)),
    {
      enabled: !!id,
    },
  );
}
